export const tabItems = ["QR 스캔", "위치 검색"];
